@let i18n = 'pages.campaignForm.sections.creatorsAndCtas.creatorAndBudget.';

<app-side-dialog class="block" [disableClose]="true" [contentMarginTop]="24" (closeDialog)="onCancelClick()">
  <div dialogHeader>
    <h2>{{ i18n + (isEditMode() ? 'editTitle' : 'title') | translate }}</h2>
  </div>

  <div dialogContent class="custom-form">
    @if (isEditMode()) {
      <div class="flex flex-col gap-4">
        @if (selected().length) {
          <div class="creator-picker-tray">
            @for (item of selected(); track item.creator.id) {
              <ng-container *ngTemplateOutlet="trayRow; context: { $implicit: item, removable: false }" />
            }
          </div>
        }

        <ng-container *ngTemplateOutlet="footer" />
      </div>
    } @else {
      <div #pickerRoot class="flex flex-col gap-4">
        <div class="flex items-center gap-3">
          <mat-form-field class="flex-1">
            <app-icon src="/icons/search.svg" matPrefix alt="" [size]="16" />
            <input
              #searchInput
              matInput
              cdkFocusInitial
              data-testid="creator-picker-search"
              [formControl]="searchControl"
              [placeholder]="i18n + 'searchPlaceholder' | translate"
              (keydown)="onSearchKeydown($event)"
            />
          </mat-form-field>

          <button
            mat-flat-button
            type="button"
            color="secondary-gray-border"
            class="mat-thick-button shrink-0"
            (click)="openCreatorCreateDialog()"
          >
            <div class="flex items-center gap-2">
              <app-icon src="icons/plus.svg" class="w-5 h-5" />
              {{ i18n + 'newCreator' | translate }}
            </div>
          </button>
        </div>

        <div class="flex flex-wrap items-center gap-2">
          @if (!creatorsFailed()) {
            <div class="relative">
              <mat-form-field
                class="creator-picker-filter mat-select-slim w-[220px]"
                [class.creator-picker-filter--active]="platformFilter().length"
                [class.invisible]="!creatorsLoaded()"
              >
                <mat-select
                  multiple
                  panelClass="custom-select-panel"
                  [formControl]="platformFilterControl"
                  [placeholder]="i18n + 'platformFilter' | translate"
                >
                  <mat-select-trigger>
                    {{ i18n + 'platformFilter' | translate }} ({{ platformFilter().length }})
                  </mat-select-trigger>

                  @for (platform of platformOptions(); track platform) {
                    <mat-option [value]="platform">{{ 'shared.platformFeatures.' + platform | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              @if (!creatorsLoaded()) {
                <ngx-skeleton-loader class="creator-picker-skeleton-overlay" [theme]="skeletonOverlayTheme" />
              }
            </div>
          }

          @if (!dialogStore.campaignOptionsFailed$()) {
            <div class="relative">
              <mat-form-field
                class="creator-picker-filter mat-select-slim w-[320px]"
                [class.creator-picker-filter--active]="campaignFilter().length"
                [class.invisible]="dialogStore.campaignOptions$() === null"
              >
                <mat-select
                  multiple
                  panelClass="custom-select-panel"
                  [formControl]="campaignFilterControl"
                  [placeholder]="i18n + 'usedInCampaignFilter' | translate"
                >
                  <mat-select-trigger>
                    {{ i18n + 'usedInCampaignFilter' | translate }} ({{ campaignFilter().length }})
                  </mat-select-trigger>

                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="campaignSearchControl"
                      [placeholderLabel]="i18n + 'searchCampaign' | translate"
                      [noEntriesFoundLabel]="i18n + 'noCampaignsFound' | translate"
                    >
                      <app-icon ngxMatSelectSearchClear src="icons/close.svg" alt="close" class="w-4 h-4" />
                    </ngx-mat-select-search>
                  </mat-option>

                  <div
                    class="flex items-center"
                    (click)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()"
                  >
                    <button
                      mat-flat-button
                      color="secondary-transparent"
                      class="mat-slim-button"
                      type="button"
                      (click)="onSelectAllCampaignsClick()"
                    >
                      {{ 'shared.selectAll' | translate }}
                    </button>
                    <button
                      mat-flat-button
                      color="secondary-transparent"
                      class="mat-slim-button"
                      type="button"
                      (click)="onUnselectAllCampaignsClick()"
                    >
                      {{ 'shared.unselectAll' | translate }}
                    </button>
                  </div>

                  @for (option of campaignOptions(); track option.id) {
                    <mat-option [value]="option.id">
                      <span class="truncate">{{ option.name }}</span>
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              @if (dialogStore.campaignOptions$() === null) {
                <ngx-skeleton-loader class="creator-picker-skeleton-overlay" [theme]="skeletonOverlayTheme" />
              }
            </div>
          }

          <button
            mat-flat-button
            type="button"
            class="mat-slim-button"
            [color]="hideAdded() ? 'secondary-pink' : 'secondary-gray-border'"
            [attr.aria-pressed]="hideAdded()"
            (click)="onHideAddedClick()"
          >
            {{ i18n + 'hideAdded' | translate }}
          </button>
        </div>

        <div class="creator-picker-box">
          <div class="creator-picker-select-all">
            @if (creatorsLoaded()) {
              <mat-checkbox
                class="!flex"
                [checked]="selectAllState() === 'all'"
                [indeterminate]="selectAllState() === 'some'"
                [disabled]="!selectableCount()"
                (change)="onSelectAllChange()"
              >
                {{
                  i18n + (selectableCount() === 1 ? 'selectAllResultsOne' : 'selectAllResults')
                    | translate: { count: selectableCount() }
                }}
              </mat-checkbox>
            } @else if (!creatorsFailed()) {
              <div class="flex items-center gap-3">
                <ngx-skeleton-loader
                  class="h-6"
                  [theme]="{ height: '24px', width: '24px', 'border-radius': '4px', margin: '0' }"
                />
                <ngx-skeleton-loader class="h-4" [theme]="{ height: '16px', width: '160px', margin: '0' }" />
              </div>
            }
          </div>

          <div #listBody class="relative" [style.height.px]="layout().listHeight">
            @if (creatorsFailed()) {
              <div class="flex flex-col items-center justify-center gap-3 h-full p-4 text-center">
                <p>{{ i18n + 'loadError' | translate }}</p>
                <button
                  mat-flat-button
                  type="button"
                  color="secondary"
                  class="mat-slim-button"
                  (click)="onRetryCreatorsClick()"
                >
                  {{ i18n + 'retry' | translate }}
                </button>
              </div>
            } @else if (!creatorsLoaded()) {
              <div class="h-full overflow-hidden">
                @for (i of skeletonRows; track i) {
                  <div class="creator-picker-row" [style.height.px]="listRowHeight">
                    <ngx-skeleton-loader
                      class="h-5 pl-0.5"
                      [theme]="{ height: '20px', width: '20px', 'border-radius': '4px', margin: '0' }"
                    />
                    <ngx-skeleton-loader
                      class="h-8"
                      [theme]="{ height: '32px', width: '32px', 'border-radius': '100vw', margin: '0' }"
                    />
                    <ngx-skeleton-loader class="h-5 flex" [theme]="{ height: '20px', width: '140px', margin: '0' }" />
                    <ngx-skeleton-loader class="h-4 flex" [theme]="{ height: '16px', width: '80px', margin: '0' }" />
                  </div>
                }
              </div>
            } @else if (!filteredRows().length) {
              <div class="flex flex-col items-center justify-center gap-3 h-full p-4 text-center">
                <p>{{ 'pages.campaignForm.sections.creatorsAndCtas.noCreatorsFound' | translate }}</p>
                <button
                  mat-flat-button
                  type="button"
                  color="secondary"
                  class="mat-slim-button"
                  (click)="openCreatorCreateDialog()"
                >
                  <div class="flex items-center gap-2">
                    <app-icon src="icons/plus.svg" class="w-4 h-4" />
                    {{ i18n + 'createCreator' | translate }}
                  </div>
                </button>
              </div>
            } @else {
              <cdk-virtual-scroll-viewport
                class="creator-picker-scroll h-full"
                data-testid="creator-picker-list"
                [itemSize]="listRowHeight"
                [minBufferPx]="listRowHeight * 4"
                [maxBufferPx]="listRowHeight * 8"
                (keydown)="onListKeydown($event)"
                (focusin)="onListFocusIn($event)"
              >
                <div
                  *cdkVirtualFor="let row of filteredRows(); let index = index; trackBy: trackRow"
                  class="creator-picker-row creator-picker-row--interactive"
                  [style.height.px]="listRowHeight"
                  [attr.data-row-index]="index"
                  [class.creator-picker-row--selected]="selectedIds().has(row.creator.id)"
                  [class.creator-picker-row--disabled]="row.alreadyAdded"
                  (click)="onRowClick(row, index, $event)"
                >
                  <mat-checkbox
                    class="!flex pointer-events-none"
                    [checked]="selectedIds().has(row.creator.id)"
                    [disabled]="row.alreadyAdded"
                    [disabledInteractive]="true"
                    [tabIndex]="index === focusableRowIndex() ? 0 : -1"
                    [aria-label]="row.creator.name"
                  />

                  <app-icon-badge
                    class="shrink-0"
                    [content]="row.creator.icon"
                    [fallbackText]="row.creator.name"
                    [size]="32"
                    [iconSize]="32"
                    [fontSize]="16"
                    [borderRadius]="100"
                  />

                  <span class="truncate">{{ row.creator.name }}</span>

                  <span class="creator-picker-row-meta truncate">
                    @for (platform of row.platforms; track platform; let last = $last) {
                      {{ 'shared.platformFeatures.' + platform | translate }}{{ last ? '' : ' · ' }}
                    }
                  </span>

                  @if (row.alreadyAdded) {
                    <span class="creator-picker-row-meta ml-auto shrink-0">
                      {{ i18n + 'alreadyInCampaign' | translate }}
                    </span>
                  }
                </div>
              </cdk-virtual-scroll-viewport>
            }

            <div
              class="creator-picker-fade creator-picker-fade--top"
              [class.creator-picker-fade--visible]="listFades().top"
            ></div>
            <div
              class="creator-picker-fade creator-picker-fade--bottom"
              [class.creator-picker-fade--visible]="listFades().bottom"
            ></div>
          </div>
        </div>

        <div class="creator-picker-tray" data-testid="creator-picker-tray">
          @if (!selected().length) {
            <p class="creator-picker-row-meta px-4 py-4">{{ i18n + 'noCreatorsSelected' | translate }}</p>
          } @else {
            <div class="flex items-center gap-3 py-2 pl-2 pr-3">
              <button
                mat-icon-button
                type="button"
                [attr.aria-expanded]="!trayCollapsed()"
                [attr.aria-label]="i18n + (trayCollapsed() ? 'showTray' : 'collapseTray') | translate"
                (click)="onTrayToggleClick()"
              >
                <span class="flex transition-transform duration-200" [class.rotate-180]="trayCollapsed()">
                  <app-icon src="icons/chevron-down.svg" class="w-4 h-4" />
                </span>
              </button>

              <span class="font-semibold">{{ i18n + 'selected' | translate }}</span>
              <span class="creator-picker-badge">{{ selected().length }}</span>

              <div class="flex-1"></div>

              @if (hasPayout()) {
                <span class="text-sm whitespace-nowrap">{{ i18n + 'samePayout' | translate }}</span>
                <app-budget
                  class="w-36"
                  [control]="bulkCostControl"
                  [notDisclosedLabel]="i18n + 'amount' | translate"
                  [currency]="campaign().currency!"
                />
                <button
                  mat-flat-button
                  type="button"
                  class="mat-slim-button !min-w-0"
                  [disabled]="!bulkCostControl.value"
                  (click)="onApplyToAllClick()"
                >
                  {{ i18n + 'applyToAll' | translate }}
                </button>
              }
            </div>

            @if (!trayCollapsed()) {
              <div class="relative creator-picker-tray-rows">
                <div
                  #trayRows
                  class="creator-picker-scroll overflow-y-auto"
                  [style.height.px]="layout().trayRowsHeight"
                  (scroll)="onTrayScroll()"
                >
                  @for (item of selected(); track item.creator.id) {
                    <ng-container *ngTemplateOutlet="trayRow; context: { $implicit: item, removable: true }" />
                  }
                </div>

                <div
                  class="creator-picker-fade creator-picker-fade--top creator-picker-fade--tray"
                  [class.creator-picker-fade--visible]="trayFades().top"
                ></div>
                <div
                  class="creator-picker-fade creator-picker-fade--bottom creator-picker-fade--tray"
                  [class.creator-picker-fade--visible]="trayFades().bottom"
                ></div>
              </div>
            }
          }
        </div>

        <ng-container *ngTemplateOutlet="footer" />
      </div>
    }
  </div>
</app-side-dialog>

<ng-template #trayRow let-item let-removable="removable">
  <div class="creator-picker-row" [style.height.px]="trayRowHeight">
    <app-icon-badge
      class="shrink-0"
      [content]="item.creator.icon"
      [fallbackText]="item.creator.name"
      [size]="32"
      [iconSize]="32"
      [fontSize]="16"
      [borderRadius]="100"
    />

    <span class="truncate flex-1">{{ item.creator.name }}</span>

    @if (hasPayout()) {
      <app-budget
        class="w-44 shrink-0"
        [control]="item.cost"
        [notDisclosedLabel]="i18n + 'noBudget' | translate"
        [currency]="campaign().currency!"
      />
    }

    @if (removable) {
      <button
        mat-icon-button
        type="button"
        class="shrink-0"
        [attr.aria-label]="i18n + 'removeCreator' | translate: { name: item.creator.name }"
        (click)="onRemoveSelectedClick(item.creator.id)"
      >
        <app-icon src="icons/close.svg" alt="" class="w-4 h-4" />
      </button>
    }
  </div>
</ng-template>

<ng-template #footer>
  <div class="flex flex-col gap-4">
    <hr />

    <div class="flex items-center justify-between gap-3">
      <div
        matTooltipPosition="above"
        [matTooltip]="'pages.campaignForm.sections.creatorsAndCtas.creatorAndBudget.noCommonPlatforms' | translate"
        [matTooltipDisabled]="!selected().length || hasCommonPlatforms()"
      >
        <button
          mat-flat-button
          type="button"
          color="secondary"
          [disabled]="!selected().length || !hasCommonPlatforms()"
          (click)="onSubmitClick(true)"
        >
          {{ 'pages.campaignForm.sections.creatorsAndCtas.creatorAndBudget.continueWithDeliverable' | translate }}
        </button>
      </div>

      <div class="flex items-center gap-3">
        <button mat-flat-button type="button" color="secondary-transparent" (click)="onCancelClick()">
          {{ 'shared.cancel' | translate }}
        </button>

        <button
          mat-flat-button
          type="button"
          data-testid="creator-picker-submit"
          [disabled]="!selected().length"
          (click)="onSubmitClick()"
        >
          @if (isEditMode()) {
            {{ 'shared.save' | translate }}
          } @else if (selected().length === 1) {
            {{ 'pages.campaignForm.sections.creatorsAndCtas.creatorAndBudget.addOneCreator' | translate }}
          } @else {
            {{
              'pages.campaignForm.sections.creatorsAndCtas.creatorAndBudget.addCreators'
                | translate: { count: selected().length }
            }}
          }
        </button>
      </div>
    </div>
  </div>
</ng-template>
